import React from "react";
import { Link, NavLink } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Navbar from "../../Navbar/Navbar";
import korgazma from "../../assets/korgazma1.png"

import Mundareja from "../Mundareja/Mundareja";

export default function KorgazmaMaterial() {
  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="text-name">
          <h1>Biznes Asoslari</h1>
        </div>
        <div className="left">
          <Link to="/" className="bosh">
            Bosh sahifa
          </Link>
          <Link to="/boshlangich-talim" className="left-material bosh">
            Boshlang’ich kasbiy ta’lim
          </Link>
          <Link>Biznes Asoslari</Link>
        </div>
        <div className="text-box">
          <Mundareja />
          <div className="text-right">
            <div className="materiallar">
              <div className="material-btn">
                <NavLink to="/textpage">Maruza matn</NavLink>
              </div>
              <div className="material-btn">
                <NavLink to="/mediamaterial">Media materiallar</NavLink>
              </div>
              <div className="material-btn">
                <NavLink to="/korgazma">Ko‘rgazma materiallari </NavLink>
              </div>
              <div className="material-btn">
                <NavLink to="">Taqdimotlar</NavLink>
              </div>
            </div>
            <div className="korgazma-home">
              <div className="korgazma-images">
                <div className="korgazma-left">
                  <div className="korgazma-img">
                    <img src={korgazma} alt="" />
                  </div>
                </div>
                <div className="korgazma-right">
                  <p>10 materiallar</p>
                  <div className="korgazma-right-images">
                    <div className="korgazma-right-img">
                      <img src={korgazma} alt="" />
                    </div>
                    <div className="korgazma-right-img">
                      <img src={korgazma} alt="" />
                    </div>
                    <div className="korgazma-right-img">
                      <img src={korgazma} alt="" />
                    </div>
                    <div className="korgazma-right-img">
                      <img src={korgazma} alt="" />
                    </div>
                    <div className="korgazma-right-img">
                      <img src={korgazma} alt="" />
                    </div>
                    <div className="korgazma-right-img">
                      <img src={korgazma} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="korgazma-text">
                <p className="korgazma-title">Course Details</p>
                <span>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
                  maecenas accumsan lacus vel facilisis consectetur adipiscing
                  elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  sed do eiusmod tempor incididunt ut labore et dolore magna
                  aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo
                  viverra maecenas accumsan.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
